var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIconTransit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "icon-transit",
    xmlns: "http://www.w3.org/2000/svg",
    width: 35.991,
    height: 35.991,
    viewBox: "0 0 68.352 59",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("path", {
    id: "motorbike",
    d: "M54.505,31.792,50.513,15.861a8.042,8.042,0,0,0,2.885.53H58.65a2.944,2.944,0,0,0,2.944-2.944V2.944A2.944,2.944,0,0,0,58.65,0H53.4a8.242,8.242,0,0,0-7.642,5.252H34.888a2.944,2.944,0,0,0,0,5.887h5.993v19a5.252,5.252,0,0,1-5.24,5.24h-2.6v-12.6a1.766,1.766,0,0,0-1.766-1.766H24.209V3.532A2.932,2.932,0,0,0,21.265.589H12.281A12.293,12.293,0,0,0,0,12.811v9.973a2.944,2.944,0,0,0,2.944,2.944H8.4A20.088,20.088,0,0,0,1.177,41.141v5.793A1.766,1.766,0,0,0,2.944,48.7h4.71a1.3,1.3,0,0,0,0,.212,9.749,9.749,0,1,0,19.487,0V48.7H45.921a1.036,1.036,0,0,0,0,.188,9.749,9.749,0,1,0,19.487,0,1.036,1.036,0,0,0,0-.188h1.177a1.766,1.766,0,0,0,1.766-1.766A15.2,15.2,0,0,0,54.5,31.792ZM53.4,5.887h2.355V10.5H53.4a2.355,2.355,0,1,1,0-4.616ZM5.887,12.811a6.405,6.405,0,0,1,6.394-6.394h6.076V19.84H5.887Zm15.366,36.1a3.862,3.862,0,1,1-7.712,0,1.3,1.3,0,0,0,0-.212H21.3A1.3,1.3,0,0,0,21.253,48.912Zm38.28,0a3.862,3.862,0,1,1-7.712,0,1.035,1.035,0,0,0,0-.188h7.76A1.036,1.036,0,0,0,59.533,48.912Z",
    fill: "#fff"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconTransit);
export default __webpack_public_path__ + "static/media/icon-transit.4b0f226c591b5b38e7730add0fa0dcdf.svg";
export { ForwardRef as ReactComponent };